module.exports = __webpack_public_path__ + "static/media/hawthorn-logo.f5f3a3eb.svg";